.wrapper {
  display: grid;
}

.loginwrapper {
  display: grid;
  background: var(--color-background);
  min-height: 100vh;
  overflow-x: hidden;
}

.loginwrapper > main {
  grid-area: main;
}

.loginwrapper > header {
  grid-area: header;
  text-align: right;
  padding: var(--outer-gutter);
}

.loginwrapper > footer {
  grid-area: footer;
  text-align: center;
  color: var(--color-text);
  font-size: var(--font-size-xs);
}

.loginseparator {
  color: var(--color-grey-light);
  font-size: var(--font-size-xs);
  text-align: center;
}

.loginseparator::before,
.loginseparator::after {
  background-color: var(--color-grey-lighter);
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 70px;
  margin: 1em;
}

@media (min-width: 576px) {
  .wrapper {
    grid-template-columns: var(--sidebar-width) 1fr;
  }

  .loginwrapper {
    grid-template: 80px auto 30px / auto 500px auto;
    grid-template-areas:
      "header header header"
      ". main ."
      ". footer .";
  }

  .fixed {
    grid-template-columns: var(--sidebar-width-expanded) 1fr;
  }
}

.content {
  background: var(--color-background);
  min-height: 100vh;
  overflow-x: hidden;
}

.logo {
  color: var(--color-primary);
  height: 86px;
  display: block;
  margin: auto;
  align-content: center;
  text-align: center;
}

.logo > svg {
  height: 80px;
}

.vspace {
  padding-top: 1em;
  padding-bottom: 1em;
}

.container {
  width: 100%;
  max-width: var(--max-container-width);
  margin: 0 auto;
  padding: var(--outer-gutter);
}
@media (min-width: 576px) {
  .container {
    padding: var(--outer-gutter-desktop);
  }
}
